import React from "react"
import ListGroup from "reactstrap/lib/ListGroup"
import ListGroupItem from "reactstrap/lib/ListGroupItem"
import ListGroupItemHeading from "reactstrap/lib/ListGroupItemHeading"
import ListGroupItemText from "reactstrap/lib/ListGroupItemText"

export default function AddressList({
  addressList,
  onEditClick,
  onDeleteClick,
  onRadioChange,
}) {
  return (
    <ListGroup>
      {addressList.map((address) => (
        <ListGroupItem className="justify-content-between" key={address?.id}>
          <ListGroupItemHeading style={{ fontSize: "1.2rem" }}>
            {address.name}
          </ListGroupItemHeading>
          <div style={{ display: "flex", alignItems: "center" }}>
            {onRadioChange && (
              <input
                type="radio"
                id={address?.id}
                name="address"
                value={address?.id}
                style={{ marginRight: 10 }}
                onChange={() => onRadioChange(address)}
              />
            )}
            <ListGroupItemText style={{ flex: 1, margin: 0 }}>
              {[
                address?.addressLine1,
                address?.addressLine2,
                address?.city,
                address?.state,
                address?.zip,
              ]
                ?.filter((d) => d)
                ?.join(", ")}
            </ListGroupItemText>
            <div>
              {onEditClick && (
                <i
                  className="fas fa-edit"
                  style={{
                    margin: "0 25px",
                    fontSize: 25,
                    cursor: "pointer",
                  }}
                  onClick={() => onEditClick(address?.id)}
                />
              )}

              {onDeleteClick && (
                <i
                  className="fas fa-trash-alt"
                  style={{
                    margin: "0 25px",
                    fontSize: 25,
                    cursor: "pointer",
                  }}
                  onClick={() => onDeleteClick(address?.id)}
                />
              )}
            </div>
          </div>
        </ListGroupItem>
      ))}
    </ListGroup>
  )
}
